import React from "react";
import { Box, Card, CardContent, Chip, Grid, Typography } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";

import Truth, { type TruthState } from "../ops/Truth";
import { type FixQueueRow } from "./adminBandFormat";

interface OperationalBandProps {
  completions: TruthState<number>;
  freshness: TruthState<number>;
  fixQueueAffected: TruthState<number>;
  fixQueueRows: FixQueueRow[];
  onRetry: () => void;
  onSelectFixSignature: (row: FixQueueRow) => void;
}

const OperationalBand: React.FC<OperationalBandProps> = ({
  completions,
  freshness,
  fixQueueAffected,
  fixQueueRows,
  onRetry,
  onSelectFixSignature,
}) => (
  <Card sx={{ mb: 3 }}>
    <CardContent>
      <Typography variant="overline" color="text.secondary" fontWeight={700}>
        Operations — measured state
      </Typography>

      <Grid container spacing={2} alignItems="stretch" sx={{ mt: 0.25 }}>
        <Grid item xs={12} md={4}>
          <Truth
            label="Properties completed today"
            state={completions}
            onRetry={onRetry}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Truth
            label="Safe to quote right now"
            state={freshness}
            onRetry={onRetry}
            showPercent
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Truth
            label="Buildings represented in the fix queue"
            state={fixQueueAffected}
            onRetry={onRetry}
          />
        </Grid>
      </Grid>

      {fixQueueAffected.status === "ok" && fixQueueAffected.value > 0 && (
        <Box mt={2.5}>
          <Box display="flex" alignItems="center" gap={1} mb={1}>
            <BuildIcon fontSize="small" sx={{ color: "text.secondary" }} />
            <Typography variant="subtitle2" fontWeight={700}>Fix queue</Typography>
            <Typography variant="caption" color="text.secondary">
              root-cause groups · click to inspect sample buildings
            </Typography>
          </Box>
          <Box display="flex" flexWrap="wrap" gap={1}>
            {fixQueueRows.map((row) => (
              <Chip
                key={row.failure_signature}
                label={row.failure_signature.replace(/_/g, " ")}
                onClick={() => onSelectFixSignature(row)}
                variant="outlined"
                color={row.fix_class === "capture_layer" ? "warning" : "error"}
                sx={{ fontWeight: 600 }}
              />
            ))}
          </Box>
        </Box>
      )}
    </CardContent>
  </Card>
);

export default OperationalBand;
